const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api').replace(/\/$/, '');

async function request(path, signal) {
  const response = await fetch(`${API_BASE_URL}${path}`, { signal, headers: { Accept: 'application/json' } });
  const body = await response.json().catch(() => null);
  if (!response.ok) {
    const error = new Error(body?.error?.message || 'Unable to load the catalogue.');
    error.code = body?.error?.code || 'CATALOGUE_REQUEST_FAILED';
    throw error;
  }
  return body;
}

export function getProducts(filters = {}, signal) {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== '' && value !== null && value !== undefined) params.set(key, value);
  });
  const query = params.toString();
  return request(`/products${query ? `?${query}` : ''}`, signal);
}

export function getProduct(slug, signal) {
  return request(`/products/${encodeURIComponent(slug)}`, signal);
}

export function getWellnessConcerns(signal) { return request('/products/wellness-concerns', signal); }
